import { getGlobalMapRef, getViewport } from "features/map/GlobalViewState"
import { PickingInfo } from "@deck.gl/core"

// This function exists to resolve mouse events to account for maplibre terrain
// Try unprojecting from maplibre first, with deckGL as a fallback
// when trying to unproject a point from a user interaction
export const resolveEventLngLat = (event: MouseEvent) => {
    const mapRef = getGlobalMapRef()?.current?.getMap()

    const x = event.offsetX
    const y = event.offsetY

    const lngLat = mapRef?.unproject?.([x, y])

    if (lngLat) {
        return { longitude: lngLat.lng, latitude: lngLat.lat }
    }

    const [longitude, latitude] = getViewport().unproject([x, y])
    return { longitude, latitude }
}

// Resolve deck PickingInfo to a terrain-aware lng/lat
export const resolveDeckPickingLngLat = (info: PickingInfo) => {
    const { x, y } = info

    const mapRef = getGlobalMapRef()?.current?.getMap()

    const lngLat = mapRef?.unproject?.([x, y])

    if (lngLat) {
        return { longitude: lngLat.lng, latitude: lngLat.lat }
    }

    // Fallback
    const [longitude, latitude] = getViewport().unproject([x, y])
    return { longitude, latitude }
}
